module.exports = __webpack_public_path__ + "static/media/summer15-3 (1).4d3b004c.png";